import queryString from "query-string";

import { INTEREST_PREVIEW } from "constants/actionTypes";
import { CreditDebit } from "constants/interest";

import { serializeInterestPreview } from "lib/serializers/interestPreview";

import { offlineActionCreator } from "./lib";

export interface InterestPreviewRequest {
  chargeToDate: string;
  chargeFromDate?: string | null;
  creditDebit?: CreditDebit;
}

export const getInterestUrl = ({
  chargeToDate,
  chargeFromDate,
  creditDebit,
}: InterestPreviewRequest) =>
  queryString.stringifyUrl(
    {
      url: "/v2/interest/",
      query: {
        charge_to_date: chargeToDate,
        charge_from_date: chargeFromDate || undefined,
        credit_debit: creditDebit,
      },
    },
    { arrayFormat: "none" },
  );

export const InterestPreviewAction = offlineActionCreator(
  INTEREST_PREVIEW,
  serializeInterestPreview,
  getInterestUrl,
  false,
);
